import UserService from './UserService'
import BrowserService from "./BrowserService";
import {PDFConvertService} from './PDFConvertService'
import {UserBehaviorTrackingService} from "./UserBehaviorTrackingService";
import {AccountService} from './AccoutService';
import PDFViewerService from './PDFViewerService';
import TASK_MAP from './TaskMap/TaskMap'
import {collaborationService, collaborationAnnotEvent, collaborationMqttService} from './Collaboration/index'
import TeamsAppService from 'Store/services/TeamsAppService';
import ESignChinaService from 'Store/services/eSignChinaService';
import StorageService from './StorageService';
import IDoxService from './IDoxService';
import LocalToGlobal from './LocalToGlobal'
import SharePointService from './SharePoint/SharePointService'
import DrivesService from './DrivesService'
import IManageService from './IManage/IManageService'
import ChromeExtensionService from './ChromeExtensionService';
import ThirdPartyService from './ThirdPartyService';
import ShortcutService from './ShortcutService';
import PluginService from './PluginService';

const drivesService = new DrivesService()
const sharePointService = new SharePointService()
const userService = new UserService();
const browserService = new BrowserService();

const convertService = new PDFConvertService();
const userBehaviorTrackingService = new UserBehaviorTrackingService()
const accountService = new AccountService();

const teamsAppService = new TeamsAppService();
const storageService = new StorageService()
const iDoxService = new IDoxService();
const pdfViewerService = new PDFViewerService();
const eSignChinaService = new ESignChinaService();
const localToGlobal = new LocalToGlobal()
const iManageService = new IManageService()
const chromeExtensionService = new ChromeExtensionService();
const thirdPartyService = new ThirdPartyService();
new ShortcutService();
new PluginService();

window.__thirdPartyService__ = thirdPartyService

export {
    drivesService,
    iManageService,
    localToGlobal,
    sharePointService,
    collaborationService,
    collaborationAnnotEvent,
    collaborationMqttService,
    userService,
    browserService,
    convertService,
    userBehaviorTrackingService,
    accountService,
    TASK_MAP,
    teamsAppService,
    eSignChinaService,
    storageService,
    iDoxService,
    pdfViewerService,
    chromeExtensionService,
    thirdPartyService
};

